import Vue from 'vue';

const MessageComponent = require('./ai-message.vue').default;

const MessageConstructor = Vue.extend(MessageComponent);

const AiMessage = (options, type = 'basic') => {
  const settings = { type };

  if (typeof options === 'string') {
    settings.message = options;
  } else {
    Object.assign(settings, options);
  }

  const data = () => (settings);

  const MessageInstance = new MessageConstructor({ data });
  MessageInstance.vm = MessageInstance.$mount();
  MessageInstance.vm.visible = true;
  document.body.appendChild(MessageInstance.vm.$el);

  return MessageInstance.vm;
};

['basic'].forEach((type) => {
  AiMessage[type] = options => AiMessage(options, type);
});

export default AiMessage;
